import { render, staticRenderFns } from "./EventProgram.vue?vue&type=template&id=5ca52687&scoped=true"
import script from "./EventProgram.vue?vue&type=script&lang=js"
export * from "./EventProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca52687",
  null
  
)

export default component.exports